module.exports = __webpack_public_path__ + "themes/fq/sprite/green-button@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/green-button@2x.png
// module id = 71
// module chunks = d-game